import { render, staticRenderFns } from "./TelList.vue?vue&type=template&id=7a53bf15"
import script from "./TelList.vue?vue&type=script&lang=js"
export * from "./TelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports